// extracted by mini-css-extract-plugin
export default {"bottomFrame":"ListingTileWithPopup-module__bottomFrame__fzv7w","popupWrapper":"ListingTileWithPopup-module__popupWrapper__IYHQL"};